module.exports = __webpack_public_path__ + "img/ic_teacher_sheji.534bb1a8.jpg";